import TypoGraphy from "@/typography";
import './index.scss';
import { projectImages } from "public/Assets/Images";
import MentorDetails from "../MentorDetails";
import Button from "@/uicomponents/Button";
import useViewType from "@/utils/Hooks/useViewType";
import { VideoDetailProps } from "@/interfaces";
import { useRouter } from "next/navigation";
import { RouteStrings } from "@/utils/routestrings";
import { useState } from "react";
const VideoDetailCard = ({
  data,
  nextSchedule
}: any) => {
  const router = useRouter();
  const isMobile = useViewType();
  const rating = data.courseRating;
  const chapters = data.courseCurriculum.length;
  const difficultyLevel = data.courseDifficulty;
  const name = data.courseName;
  const description = data.courseDescription;
  const industryData = data.industries.data[0];
  const mentorDetails = data.mentors.data[0].attributes;
  const [hover, sethover] = useState(false);
  const handleButtonClick = (webinarScheduleId: number) => {
    router.push(`https://webinar.growthschool.io/webinar/${webinarScheduleId}`);
  };
  const {
    push
  } = useRouter();
  const getCardItems = () => {
    const getDifficultyImage = (level: string): string => {
      if (level.toLowerCase().includes("begin")) return projectImages.chartBeginner;
      if (level.toLowerCase().includes("inter")) return projectImages.chartIntermediate;
      return projectImages.chartAdvanced;
    };
    if (rating && chapters && difficultyLevel) {
      return <>
        <div className="item_wrapper">
          <img src={projectImages.ratingStar} alt="rating" />
          <TypoGraphy text={rating?.toString()} variant='Desktop/Caption/R | 12 |120' color="#686C7A" />
        </div>
        <div className="item_wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
            <path d="M7.92353 12.9724C8.09524 13.0123 8.11097 13.2372 7.94372 13.293L6.95622 13.618C4.47497 14.418 3.16872 13.7492 2.36247 11.268L1.56247 8.79922C0.762469 6.31797 1.42497 5.00547 3.90622 4.20547C4.28787 4.07908 4.66787 4.46496 4.57154 4.85528C4.56641 4.87605 4.56131 4.89694 4.55622 4.91797L3.94372 7.53672C3.25622 10.4805 4.26247 12.1055 7.20622 12.8055L7.92353 12.9724Z" fill="#818490" />
            <path d="M10.7314 2.50534L9.68761 2.26159C7.60011 1.76784 6.35636 2.17409 5.62511 3.68659C5.43761 4.06784 5.28761 4.53034 5.16261 5.06159L4.55011 7.68034C3.93761 10.2928 4.74386 11.5803 7.35011 12.1991L8.40011 12.4491C8.76261 12.5366 9.10011 12.5928 9.41261 12.6178C11.3626 12.8053 12.4001 11.8928 12.9251 9.63659L13.5376 7.02409C14.1501 4.41159 13.3501 3.11784 10.7314 2.50534ZM9.55636 8.83034C9.50011 9.04284 9.31261 9.18034 9.10011 9.18034C9.06261 9.18034 9.02511 9.17409 8.98136 9.16784L7.16261 8.70534C6.91261 8.64284 6.76261 8.38659 6.82511 8.13659C6.88761 7.88659 7.14386 7.73659 7.39386 7.79909L9.21261 8.26159C9.46886 8.32409 9.61886 8.58034 9.55636 8.83034ZM11.3876 6.71784C11.3314 6.93034 11.1439 7.06784 10.9314 7.06784C10.8939 7.06784 10.8564 7.06159 10.8126 7.05534L7.78136 6.28659C7.53136 6.22409 7.38136 5.96784 7.44386 5.71784C7.50636 5.46784 7.76261 5.31784 8.01261 5.38034L11.0439 6.14909C11.3001 6.20534 11.4501 6.46159 11.3876 6.71784Z" fill="#818490" />
          </svg>
          <TypoGraphy text={`${chapters} chapters`} variant='Desktop/Caption/R | 12 |120' color="#686C7A" />
        </div>
        <div className="item_wrapper">
          <img src={getDifficultyImage(difficultyLevel)} alt="chapters" />
          <TypoGraphy text={difficultyLevel} variant='Desktop/Caption/R | 12 |120' color="#686C7A" />
        </div>
      </>;
    }
    return <></>;
  };
  return <div className="video_course_wrapper" data-sentry-component="VideoDetailCard" data-sentry-source-file="index.tsx">
      {!isMobile && <div className="video_course_header">
        <TypoGraphy tagName='h3' text="Learn via Video Course" variant='Condensed/Desktop/Heading 2 | M | 24 | 120'></TypoGraphy>
      </div>}
      <div className="course_detail">
        <div className="course_content">
          {/* variant_check */}
          <TypoGraphy tagName='h4' text={name} variant='Body 1/Medium/16|120%' styles={{
          lineHeight: "140%"
        }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
          <div className="clamp-text">
            <TypoGraphy tagName='p' text={description} variant='Desktop/Body 2/R | 14 | 160' styles={{
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "140%"
          }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
          </div>
          <div className="card_items_wrapper">
            {getCardItems()}
          </div>
          <div className="card_bottom_content">
            <MentorDetails mentorImageUrl={mentorDetails.mentorImageUrl} name={mentorDetails.name} designation={mentorDetails.designation} companyName={mentorDetails.companyName} data-sentry-element="MentorDetails" data-sentry-source-file="index.tsx" />
          </div>
          <div className="cta_wrapper">
            <Button clickHandler={() => handleButtonClick(nextSchedule?.webinarScheduleId)} text='Enrol Now' textColor='white' disabled={nextSchedule?.webinarStartTime === undefined} variant='NormalVariant' backgroundColor='#030A21' textVariant='Desktop/Body 1/M | 16 |120' data-sentry-element="Button" data-sentry-source-file="index.tsx" />
            <div onClick={() => push(RouteStrings.DYNAMICROUTE(industryData.attributes.industryName.replace(/\s+/g, "-").replace(/-+/g, "-"), 'INDUSTRY', industryData.id))} style={{
            alignSelf: 'center',
            display: 'flex',
            gap: '6px'
          }}>
              <TypoGraphy text="View similar courses" tagName='p' variant={!isMobile ? 'Desktop/Body 2/R | 14 |120' : 'Desktop/Caption/R | 12 |120'} color="#353B4D" styles={{
              textDecoration: hover ? "underline" : "",
              cursor: "pointer"
            }} onMouseEnter={() => sethover(true)} onMouseLeave={() => sethover(false)} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
              <img src={projectImages.arrowCircledFilled}></img>
            </div>
          </div>
        </div>

      </div>
    </div>;
};
export default VideoDetailCard;